import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import { DESIGN_MARK_APP_START, DESIGN_MEASURE_BEFORE_APP } from '~/performance/constants';
import { performanceMarkAndMeasure } from '~/performance/utils';
import { addShortcutsExtension } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import { injectVueAppBreadcrumbs } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/breadcrumbs.js?vue3';
import { apolloProvider } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/graphql_shared/issuable_client.js?vue3';
import App from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/app.vue?vue3';
import WorkItemBreadcrumb from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/work_item_breadcrumb.vue?vue3';
import activeDiscussionQuery from './components/design_management/graphql/client/active_design_discussion.query.graphql';
import { createRouter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/router/index.js?vue3';

Vue.use(VueApollo);

export const initWorkItemsRoot = ({ workItemType } = {}) => {
  const el = document.querySelector('#js-work-items');

  if (!el) {
    return undefined;
  }

  addShortcutsExtension(ShortcutsNavigation);

  const {
    fullPath,
    defaultBranch,
    routerPath,
    // group work items list
    isGroupIssuesList,
    // service desk list
    isServiceDeskEnabled,
    isServiceDeskSupported,
    serviceDeskCalloutSvgPath,
    serviceDeskEmailAddress,
    serviceDeskHelpPath,
    serviceDeskSettingsPath,
  } = el.dataset;

  const router = createRouter({ fullPath, defaultBranch, routerPath });

  injectVueAppBreadcrumbs(router, WorkItemBreadcrumb, apolloProvider, { workItemType });

  apolloProvider.clients.defaultClient.cache.writeQuery({
    query: activeDiscussionQuery,
    data: {
      activeDesignDiscussion: {
        __typename: 'ActiveDesignDiscussion',
        id: null,
        source: null,
      },
    },
  });

  return new Vue({
    el,
    name: 'WorkItemsRoot',
    router,
    apolloProvider,
    provide: {
      fullPath,
      workItemType,
      // group work items list
      isGroupIssuesList: parseBoolean(isGroupIssuesList),
      // service desk list
      isServiceDeskEnabled: parseBoolean(isServiceDeskEnabled),
      isServiceDeskSupported: parseBoolean(isServiceDeskSupported),
      serviceDeskCalloutSvgPath,
      serviceDeskEmailAddress,
      serviceDeskHelpPath,
      serviceDeskSettingsPath,
    },
    mounted() {
      performanceMarkAndMeasure({
        mark: DESIGN_MARK_APP_START,
        measures: [
          {
            name: DESIGN_MEASURE_BEFORE_APP,
          },
        ],
      });
    },
    render(createElement) {
      return createElement(App, {
        props: {
          rootPageFullPath: fullPath,
        },
      });
    },
  });
};
